import AppConfiguration from "../../components/AppConfiguration";

function getRootUrl() {
    return AppConfiguration.getApiEndpoint();
}

export default getRootUrl;
